import { Auth } from "aws-amplify";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import PageLoader from "../../components/PageLoader";
import photo1 from "../../images/verifyyou.svg";
import FormImage from "../../layouts/formimage";
import { Constants } from "../../libs/Constants";
import { get } from "../../libs/dbFunctions";
import { placeEvent } from "../../libs/eventsLib";
import useSignUpContext from "./contexts/useSignUpContext";
const initialValues = {
  code: "",
};
const schema = yup.object({
  code: yup.string().required("Code is required"),
});

const VerificationCode = ({ props, onCancel }) => {
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user: userInfo, company: companyInfo } = useSignUpContext();
  //Method to login user
  const login = async () => {
    try {
      Auth.configure({ storage: sessionStorage });
      let auth = await Auth.signIn(
        userInfo.companyEmail.toLowerCase(),
        userInfo.password
      );

      let o = await get(Constants.dbTypes.USER, auth.username);
      props.setUserObj(o);
      props.setActiveCompany(companyInfo);
      props.userHasAuthenticated(true);
    } catch (e) {
      props.history.push("/login");
    }
  };
  // Method to resend verificaiton code
  const resendCode = async () => {
    try {
      await Auth.resendSignUp(userInfo.companyEmail.toLowerCase());
      toast.success(
        "We have sent a verification code again. Please check your email."
      );
    } catch (err) {
      if (err && err.message) {
        setErrors(err.message);
      } else {
        toast.error("Unable to send verification code. Please contact admin.");
      }
    }
  };
  const handleSubmit = async (values) => {
    setLoading(true);
    //confirm the the signup with verification code
    try {
      await Auth.confirmSignUp(
        userInfo.companyEmail.toLowerCase(),
        values.code
      );
      await placeEvent(
        Constants.EVENT_TYPES.SIGNUP_DONE,
        userInfo.companyEmail.toLowerCase(),
        {}
      );
      toast.success("Signup successful.");
      await login();
    } catch (err) {
      if (err && err.code && err.code === "CodeMismatchException") {
        setErrors("Incorrect Code");
      } else {
        if (err && err.message) {
          setErrors(err.message);
        } else {
          toast.error("Unable to sign up. Please contact admin.");
        }
      }
    }
    setLoading(false);
  };
  return (
    <PageLoader isActive={loading}>
      <FormImage
        title="Verifying the Details"
        subtitle="This helps us know that we have the current information and that it’s really your email."
        image={photo1}
        bgClass="background-purple"
      >
        <React.Fragment>
          <h2 className="text-center pb-3">We’ve sent you an email</h2>
        </React.Fragment>
        <Formik
          validationSchema={schema}
          onSubmit={handleSubmit}
          initialValues={initialValues}
        >
          {({ isValid, isSubmitting }) => (
            <Form className="w-100">
              <FormikTextField
                size="lg"
                controlId="code"
                label="Emailed Code"
                type="text"
                name="code"
                className="mb-2"
              />

              {errors && (
                <span className="invalid-feedback d-block pb-2">{errors}</span>
              )}

              <div className="d-flex font-secondary account pb-4 align-items-center">
                Didn’t receive the email?
                <Button
                  variant="link"
                  onClick={resendCode}
                  className="secondary ps-1"
                >
                  Resend
                </Button>
              </div>

              <LoaderButton
                block
                type="submit"
                variant="primary"
                size="lg"
                text="Next"
                className="mb-2"
                isLoading={isSubmitting}
                disabled={!isValid || isSubmitting}
              >
                Continue
              </LoaderButton>
            </Form>
          )}
        </Formik>
      </FormImage>
    </PageLoader>
  );
};

export default VerificationCode;
